export enum ShippingMethod {
	ReciveHome = "ReciveHome",
	PickupStore = "PickupStore",
}
